import createReducer from './reducerUtils'
import { RECOVER_FASE_VALIDATION } from '../../infrastructure/appConstants'
import { RECOVER_USER } from '../actions/actionTypes'

const initialState = {
  currentCustomer: null,
  fase: RECOVER_FASE_VALIDATION,
}

const recoverUser = (state, payload) => {
  return {
    ...state,
    currentCustomer: payload.currentCustomer,
    fase: payload.fase
  }
}


export default createReducer(initialState, {
  [RECOVER_USER]: recoverUser
})
